import {useDebugValue} from 'react';

import {
    useDatesActions,
    useDatesEvents,
    useDatesOptions,
    useDatesSelectors,
    useDatesSettings,
    useDatesTranslations,
    useDatesValues
} from './';

function useDates(props, cookies, system, abacus) {
    const {
        events
    } = useDatesEvents(props);

    const {
        options
    } = useDatesOptions(props);

    const {
        initialSettings,
        settings,
        changeSettings
    } = useDatesSettings(props, system, abacus);

    const {
        translations
    } = useDatesTranslations(props);

    const {
        defaultValues,
        initialValues,
        currentValues,
        latestValues,
        setCurrentValues,
        setCurrentValuesDefault,
        setCurrentValuesInitial,
        setCurrentValuesLatest,
        setLatestValues,
        setLatestValuesDefault,
        setLatestValuesInitial,
        setLatestValuesCurrent,
        setAllValues,
        setAllValuesDefault,
        setAllValuesInitial
    } = useDatesValues(props, cookies, system, abacus);

    const actions = useDatesActions({
        events,
        options,
        initialSettings,
        settings,
        changeSettings,
        translations,
        defaultValues,
        initialValues,
        currentValues,
        latestValues,
        setCurrentValues,
        setCurrentValuesDefault,
        setCurrentValuesInitial,
        setCurrentValuesLatest,
        setLatestValues,
        setLatestValuesDefault,
        setLatestValuesInitial,
        setLatestValuesCurrent,
        setAllValues,
        setAllValuesDefault,
        setAllValuesInitial
    });

    const selectors = useDatesSelectors({
        options,
        settings,
        translations,
        currentValues,
        latestValues
    });

    const result = {
        actions,
        events,
        options,
        selectors,
        settings,
        translations,
        currentValues,
        latestValues
    };

    useDebugValue(result);

    return result;
}

export {useDates};
